import baseApi from 'services/api/base';
import getProductKey from 'helper/requests/getProductKey';
import { WBCultureDVOptions } from 'types/Meteorology/Agro/WaterBalanceCulture/DetailedView/getOptions';
import {
  CultureGraph,
  WBCultureDVGraphParams,
} from 'types/Meteorology/Agro/WaterBalanceCulture/DetailedView/getGraph';
import { transformGetGraphResponse, transformGetOptionsResponse } from 'helper/Meteorology/Agro/WaterBalanceCulture/DetailedView';

export const waterBalanceCultureDetailedViewApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getWBCultureDVOptions: build.query<WBCultureDVOptions, void>({
      query: () => {
        const productKey = getProductKey('agro');
        return {
          url: `produtos/agro/balanco-hidrico/cultura/visao-detalhada/painel-options/?product_key=${productKey}`,
          method: 'GET',
        };
      },
      transformResponse: transformGetOptionsResponse,
    }),
    getWBCultureDVGraph: build.query<CultureGraph, WBCultureDVGraphParams>({
      query: ({
        groupId,
        locationId,
        soilId,
        cultureId,
        emergencyDate,
        startDate,
        endDate,
      }) => {
        const productKey = getProductKey('agro');
        return {
          url: `/produtos/agro/balanco-hidrico/cultura/visao-detalhada/serie-temporal/?product_key=${productKey}`,
          method: 'POST',
          body: {
            grupo_id: groupId,
            local_id: locationId,
            solo_id: soilId,
            cultura_id: cultureId,
            data_de_emergencia: emergencyDate,
            data_inicial: startDate,
            data_final: endDate,
          },
        };
      },
      transformResponse: transformGetGraphResponse,
    }),
  }),
});

export const {
  useGetWBCultureDVOptionsQuery,
  useGetWBCultureDVGraphQuery,
  useLazyGetWBCultureDVGraphQuery,
} = waterBalanceCultureDetailedViewApi;
